import { capitalize } from "lodash";
import moment from "moment";
import { FilterTimeFrameValue } from "server/config-api/index.js";
import { Granularity } from "server/dwhApi/common.js";

import { STEP_CANDIDATES } from "../wasteAmounts/constants";

const getLabelFormat = (
  period: FilterTimeFrameValue,
  granularity: Granularity,
) =>
  period === FilterTimeFrameValue.SinceBeginning
    ? "MMM YYYY"
    : granularity === Granularity.MONTH
      ? "MMM"
      : "DD MMM";

export const getPeriodLabelValueFromStartTime = ({
  period,
  granularity,
  startTime,
  timezone,
  language,
}: {
  period: FilterTimeFrameValue;
  granularity: Granularity;
  startTime: string;
  timezone: string;
  language: string;
}) => {
  const labelFormat = getLabelFormat(period, granularity);

  return capitalize(
    moment(startTime).tz(timezone).locale(language).format(labelFormat),
  );
};

export const getNiceYAxis = (maxTotal: number) => {
  const target = maxTotal / 4.5;
  const step =
    STEP_CANDIDATES.find((c) => target <= c) ??
    Math.ceil(target / 10000) * 10000;
  const niceMax = Math.max(step, Math.ceil(maxTotal / step) * step);
  const ticks: number[] = [];
  for (let v = 0; v <= niceMax; v += step) {
    ticks.push(v);
  }

  return { niceMax, ticks };
};

export const formatKg = (v: number) =>
  v === 0 ? "0" : v < 1000 ? String(v) : `${v / 1000}k`;
